import { Pressable, StyleSheet, Text, View } from "react-native";
import React from "react";

type SentryFeedbackAttachmentListProps = {
  screenshots: File[];
  onRemove: (index: number) => void;
};

export function SentryFeedbackAttachmentList({
  screenshots,
  onRemove,
}: SentryFeedbackAttachmentListProps) {
  if (screenshots.length === 0) {
    return null;
  }

  return (
    <View style={styles.attachmentList}>
      {screenshots.map((file, index) => (
        <View
          key={`${file.name}-${file.size}-${index}`}
          style={styles.attachmentRow}
        >
          <Text style={styles.attachmentText}>{file.name}</Text>
          <Pressable onPress={() => onRemove(index)}>
            <Text style={styles.removeAttachmentText}>Remove</Text>
          </Pressable>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  attachmentList: {
    gap: 6,
  },
  attachmentRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  attachmentText: {
    flex: 1,
    color: "#C9C2D4",
    fontSize: 13,
    fontFamily: "Lexend",
    lineHeight: 18,
  },
  removeAttachmentText: {
    color: "#F6F7F9",
    fontSize: 13,
    fontFamily: "Lexend",
    lineHeight: 18,
  },
});
